module.exports = "/_next/static/images/ManageYourRiskExposure@2x-751a16f1944f255e2661c70e432f5c24.webp";